import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the initial state for the multi-step form
interface ApplicationState {
  step: number;
  publisher_id: string;
  application_id: string;
  fa_name: string;
  en_name: string;
  category: string | null;
  publish_after_accept: string | null;
  description: string | null;
  fa_description: string | null;
  en_description: string | null;
  isSubmitting: boolean;
  logo: File | null; // Adding logo field
  screenshots: { id: number; url: string }[]; 
}

const initialState: ApplicationState = {
  step: 1,
  //test   publisher_id: "117633",application_id: "347065",
  publisher_id: "",
  application_id: "",
  
  fa_name: '',
  en_name: '',
  category: null,
  publish_after_accept: null,
  description: null,
  fa_description: null,
  en_description: null,
  isSubmitting: false,
  logo: null, 
  screenshots: [], 
};

const ApplicationSlice = createSlice({
  name: 'Application',
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.step < 5) state.step += 1;
    },
    previousStep: (state) => {
      if (state.step > 1) state.step -= 1;
    },
    updateField: (
      state,
      action: PayloadAction<{ field: keyof ApplicationState; value: ApplicationState[keyof ApplicationState] }>
    ) => {
      const { field, value } = action.payload;
      (state[field] as typeof value) = value;
    },
    setSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload;
    },
    resetApplication: () => initialState,
    setApplicationData: (state, action: PayloadAction<ApplicationState>) => {
      return { ...state, ...action.payload };
    },
    setLogo: (state, action: PayloadAction<File | null>) => {
      state.logo = action.payload;
    },
    setScreenshots: (state, action: PayloadAction<{ id: number; url: string }[]>) => {
      state.screenshots = action.payload;
    },
    // New actions for adding and removing screenshots
    addScreenshot: (state, action: PayloadAction<{ id: number; url: string }>) => {
      state.screenshots.push(action.payload); // Add a new screenshot
    },
    removeScreenshot: (state, action: PayloadAction<number>) => {
      state.screenshots = state.screenshots.filter((screenshot, index) => index !== action.payload); // Remove a screenshot by index
    },
  },
});

export const {
  nextStep,
  previousStep,
  updateField,
  setSubmitting,
  resetApplication,
  setApplicationData,
  setLogo, 
  setScreenshots, 
  addScreenshot, 
  removeScreenshot,
} = ApplicationSlice.actions;

export default ApplicationSlice.reducer;
